import Vue from "vue";
import axios from "axios";
import router from "@/router";
import { store } from "@/store";
import VueAxios from "vue-axios";

let axiosInstance = axios.create({ baseURL: "/api/" });
const token = localStorage.getItem("auth_token");

axiosInstance.defaults.headers.common["authorization"] = "Bearer " + token;
axiosInstance.defaults.headers.post["Content-Type"] = "multipart/form-data";
axiosInstance.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axiosInstance.defaults.headers.common["X-Requested-KEY"] =
  "74be16979710d4c4e7c6647856088456";

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("currentUser");
      delete axiosInstance.defaults.headers.common["Authorization"];
      router.replace("/auth/login");
    } else {
      store.commit("showSnackbar", {
        text: error.response.data.message || error.response.data.msg,
        stateType: "error",
        show: true
      });
    }
    return Promise.reject(error);
  }
);

window.Vue = Vue;
window.axios = axiosInstance;
Vue.use(VueAxios, window.axios);
